/**
 * @author lifei
 * 功能： actions,
 *  1. options 参数暂不启用，需要重新规划
 */
import { aUser } from '@/apis'
import { isArray, isNull } from 'lodash-es'
import { Cache } from '@/tools'
import { eventEmitter } from '@/tools'

export class Login<T extends TCommon.TStore.State, K extends TCommon.TStore.State> {
  /**
   * 功能：处理业务组 id
   */
  private handleBusId = (rootState: T) => {
    let bus: TCommon.OrNull<TUser.Login['ApiGetInfo']['res']['busGroupDtoList'][number]> = null

    const { sUserInfo, sBusId } = rootState
    const busGroupDtoList = sUserInfo?.busGroupDtoList

    let busId = sBusId || Cache.BUS_ID.getItem()

    if (isArray(busGroupDtoList)) {
      bus = busGroupDtoList.find((item) => item.busId === busId) || busGroupDtoList[0]
    }

    eventEmitter.emit('API:HEADERS', {
      busGroupCode: bus?.busCode || '12312300088',
    })

    rootState.sBusId = bus?.busId || null

    return new Promise(() => {
      Cache.BUS_ID.setItem(rootState.sBusId)
    })
  }

  /**
   * 功能：获取用户信息
   */
  userInfo = async (rootState: T): Promise<T['sUserInfo']> => {
    const { sUserInfo, sLoginInfo } = rootState

    if (isNull(sUserInfo) && sLoginInfo?.access_token) {
      const info = await aUser.login.getInfo()
      rootState.sUserInfo = {
        ...info,
        busGroupDtoList: info?.busGroupDtoList ?? info?.busGroupDTOList,
      }
    }

    this.handleBusId(rootState)

    return Promise.resolve(rootState.sUserInfo)
  }

  /**
   * 功能：清空用户登录信息
   */
  emptyUserInfo = (rootState: T) => {
    rootState.sUserInfo = null
    return Promise.resolve()
  }

  /**
   * 功能：获取用户登录信息
   */
  loginInfo = async (rootState: T, state: T['sLoginInfo']): Promise<T['sLoginInfo']> => {
    rootState.sLoginInfo = state
    eventEmitter.emit('API:HEADERS', {
      token: state?.access_token,
    })
    return new Promise((resolve) => {
      Cache.LOGIN_INFO.setItem(rootState.sLoginInfo)
      resolve(rootState.sLoginInfo)
    })
  }

  /**
   * 功能：登录 action
   */
  doLogin = async (rootState: T, params: TUser.Login['ApiDoLogin']['req']): Promise<void> => {
    const data = await aUser.login.doLogin(params)
    await this.loginInfo(rootState, data)
    await this.userInfo(rootState)
    return Promise.resolve()
  }

  /**
   * 功能：记住密码
   */
  rememberPwd = () => {}
}
